import { OptionalGroupService } from "core/service";
import BaseRepository from "core/repository/base.repository";

class OptionalGroupRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "optionalGroup";
  }

  resourceName() {
    return "grupoDeOpcionais";
  }

  getServiceProvider() {
    return OptionalGroupService;
  }

  async createOptionalGroup(params) {
    return this.mService.create(params);
  }

  async getOptionalGroup(optionalGroupUuid) {
    return this.mService.fetchByUuid(optionalGroupUuid);
  }

  async updateOptionalGroup(optionalGroupUuid, params) {
    return this.mService.update(optionalGroupUuid, params);
  }

  async deleteOptionalGroup(optionalGroupUuid, params) {
    return await this.mService.update(optionalGroupUuid, {
      ...params,
      deleted: true
    });
  }
}

export default new OptionalGroupRepository();



// WEBPACK FOOTER //
// ./src/core/repository/optional-group.repository.js